import Dropdown from "components/atoms/Dropdown";
import { useEffect } from "react";
import usePlansState from "recoilStore/Building/usePlansState";
import { BuildingPlansOutcomes } from "utils/enums";
import styles from "./PlanComparator.module.scss";

function PlanComparator() {
    const { buildingModelCarbonReductionPlans, baselinePlan, setReferencedPlanId, setComparedPlanId } = usePlansState();

    const baselinePlanFormatted = {
        id: baselinePlan.carbonReductionPlanUid,
        displayValue: BuildingPlansOutcomes.baselinePlan,
        itemId: baselinePlan.carbonReductionPlanUid,
        disable: false,
    };

    const plansFormatedDropdown = [
        ...buildingModelCarbonReductionPlans.map((plan) => ({
            id: plan.id,
            displayValue: plan.name,
            itemId: plan.id,
            disable: false,
        })),
    ];

    const plansFormatedDropdownWithBaseline = [...plansFormatedDropdown, baselinePlanFormatted];

    const audettePlan = plansFormatedDropdown?.find(
        (plan) => plan.displayValue.toLowerCase() === BuildingPlansOutcomes.audettePlan
    );

    useEffect(() => {
        if (audettePlan) {
            setReferencedPlanId(audettePlan.id);
        }

        if (baselinePlanFormatted) {
            setComparedPlanId(baselinePlanFormatted.id);
        }
    }, [audettePlan?.id, baselinePlanFormatted.id]);

    return (
        <div className={styles.planComparatorContainer}>
            <Dropdown
                hideTitle={true}
                items={plansFormatedDropdown}
                onSelectItem={({ id }) => setReferencedPlanId(id)}
                selectId="building-page-reference-plan"
                placeholder="Reference Plan"
                defaultItem={audettePlan || baselinePlanFormatted}
            />
            <Dropdown
                items={plansFormatedDropdownWithBaseline}
                onSelectItem={({ id }) => setComparedPlanId(id)}
                selectId="building-page-compared-plan"
                placeholder="Compared Plan"
                defaultItem={baselinePlanFormatted}
            />
        </div>
    );
}

export default PlanComparator;
